

















import { Component, Inject, Vue } from "vue-property-decorator";
import { IImportProviderData, IImportProviderMethods } from "@/models/imports";

@Component({
  components: {
    "import-step-vessel": () =>
      import("@/components/app/admin/imports/importStepVessel.vue")
  }
})
export default class ImportSteps extends Vue {
  // Inject

  @Inject({ from: "importProvider" })
  public readonly $importProvider!: () => IImportProviderData;

  @Inject({ from: "importMethods" })
  public readonly $importMethods!: IImportProviderMethods;

  // Computed

  public get $importData() {
    return this.$importProvider();
  }
}
